import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4eabd5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["src"]

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { Flash } from '@/core/Flash';
import { getAllWhitelabelColors, Partner, PartnerWhitelabeling, usePartner } from '@/modules/partner/Partner';
import { ErrorBag, handleFormError, handleLoadError } from '@/core/common';
import PageLayout from '@/core/components/PageLayout.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppCheck from '@/core/components/form/AppCheck.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppColorInput from '@/core/components/form/AppColorInput.vue';
import AppFileInput from '@/core/components/form/AppFileInput.vue';
import AppModal from '@/core/components/AppModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnerWhitelabel',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const store = useStore<AppStore>();
const route = useRoute();
const router = useRouter();
const resource = usePartner();
const partner = ref<Partner | null>(null);
const whitelabel = ref<Partial<PartnerWhitelabeling>>({});
const newLogotypeFile = ref<File | null>(null);
const newBackgroundFile = ref<File | null>(null);
const isActive = ref<boolean>(false);
const colors = computed<Record<string, string>[]>(() => store.getters.whitelabelColors);
const pageTitle = computed(() => interpolate(
	$gettext('Whitelabel för återförsäljare %{ name }'),
	{name: partner.value?.name || ''},
));
const isBackgroundModalOpen = ref<boolean>(false);
const errors = ref<ErrorBag>({});

const load = async () => {
	try {
		partner.value = await resource.get(route.params.id as string);
		whitelabel.value = partner.value.whitelabeling || {};
		isActive.value = !!partner.value.whitelabeling;

		await getAllWhitelabelColors();

	} catch (e) {
		handleLoadError(e as Error, 'partner.index');
	}
};

watch(route, () => {
	if (route.params.id) {
		load();
	}
});
onBeforeMount(load);

const logotypeSelected = (file: File) => {
	newLogotypeFile.value = file;
};

const backgroundSelected = (file: File) => {
	newBackgroundFile.value = file;
};

const save = async () => {
	errors.value = {};

	if (!partner.value) {
		return;
	}

	if (!isActive.value) {
		await resource.deleteWhitelabeling(partner.value.id);
		whitelabel.value = {};

		Flash.success($gettext('Återförsäljarens whitelabel har tagits bort.'));

		return;
	}

	try {
		partner.value = await resource.putWhitelabeling(partner.value.id, whitelabel.value);

		if (newLogotypeFile.value) {
			partner.value = await resource.putWhitelabelingImage('logotype', partner.value.id, newLogotypeFile.value);
			newLogotypeFile.value = null;
		}

		if (newBackgroundFile.value) {
			partner.value = await resource.putWhitelabelingImage('background', partner.value.id, newBackgroundFile.value);
			newBackgroundFile.value = null;
		}

		whitelabel.value = partner.value.whitelabeling || {};

		Flash.success($gettext('Återförsäljarens whitelabel har sparats.'));

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

const cancel = () => {
	router.push({ name: 'partner.index' });
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": pageTitle.value,
    baseTag: "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, {
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, { onClick: cancel }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Avbryt")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Spara")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AppFormGroup, {
          id: "whitelabel_active",
          label: _unref($gettext)('Aktivera whitelabel')
        }, {
          before: _withCtx(() => [
            _createVNode(AppCheck, {
              id: "whitelabel_active",
              modelValue: isActive.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isActive).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (isActive.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(AppFormGroup, {
                id: "whitelabel_logotype",
                label: _unref($gettext)('Logotyp')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppFileInput, {
                    id: "whitelabel_logotype",
                    errors: errors.value.logotype_path,
                    accept: "image/*",
                    onFile: logotypeSelected
                  }, null, 8, ["errors"])
                ]),
                _: 1
              }, 8, ["label"]),
              (whitelabel.value.logotype_path)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                    _createElementVNode("img", {
                      src: `/${whitelabel.value.logotype_path}`,
                      alt: "",
                      class: "whitelabel-logo-preview"
                    }, null, 8, _hoisted_3)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(AppFormGroup, {
                id: "whitelabel_background",
                label: _unref($gettext)('Bakgrundsbild login & formulär')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppFileInput, {
                    id: "whitelabel_background",
                    errors: errors.value.background_path,
                    accept: "image/*",
                    onFile: backgroundSelected
                  }, null, 8, ["errors"])
                ]),
                _: 1
              }, 8, ["label"]),
              (whitelabel.value.background_path)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                    _createVNode(AppButton, {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isBackgroundModalOpen.value = true), ["prevent"]))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Visa ")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(AppFormGroup, {
                id: "whitelabel_domain",
                label: _unref($gettext)('Domän')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppInput, {
                    id: "whitelabel_domain",
                    modelValue: whitelabel.value.domain,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((whitelabel.value.domain) = $event)),
                    pattern: "^[a-z0-9._-]{1,128}$",
                    errors: errors.value.domain
                  }, null, 8, ["modelValue", "errors"])
                ]),
                _: 1
              }, 8, ["label"]),
              _withDirectives((_openBlock(), _createElementBlock("h2", null, [
                _createTextVNode("Systemfärger")
              ])), [
                [_directive_translate]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colors.value, (colorName, colorKey) => {
                return (_openBlock(), _createBlock(AppColorInput, {
                  key: colorKey,
                  id: `whitelabel_color_${colorKey}`,
                  label: colorName,
                  modelValue: whitelabel.value[colorKey],
                  "onUpdate:modelValue": ($event: any) => ((whitelabel.value[colorKey]) = $event),
                  errors: errors.value[colorKey]
                }, null, 8, ["id", "label", "modelValue", "onUpdate:modelValue", "errors"]))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (isBackgroundModalOpen.value)
        ? (_openBlock(), _createBlock(AppModal, {
            key: 0,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (isBackgroundModalOpen.value = false))
          }, {
            header: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("h1", null, [
                _createTextVNode("Bakgrundsbild login & formulär")
              ])), [
                [_directive_translate]
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, [
                _createElementVNode("img", {
                  src: `/${whitelabel.value.background_path}`,
                  alt: "",
                  class: "whitelabel-background-preview"
                }, null, 8, _hoisted_5)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["page-title", "onSubmit"]))
}
}

})